import React, { useState } from "react";
import {  putUpdatePrintFileFetch } from "../../features/action/fetchPrint";
import { ShowItem } from "../common/ShowItem";
import { getImageFileFetch } from "../../features/action/fetchImage";
import { useDispatch, useSelector } from "react-redux";
import { FaPrint } from "react-icons/fa6";
import { DateTo, MembersBlock } from "./mainBloks";
import { DateFrom } from "./mainBloks";

export const Strip = ({ i, color }) => {
  const { image, loadingImage } = useSelector((state) => state.imageFile);
  const [showItems, setShowItems] = useState(false);
  const dispatch = useDispatch();
        
  const handleOpenImage = (key, url) => {
    
    setShowItems(key);
    dispatch(getImageFileFetch(url));
  };
  return (
    <React.Fragment>
      {i.item.map((a, k1) => (
        <div
          className="flex flex-row h-[64px] w-[100%] mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb] mx-auto"
          key={k1}
        >
          {DateFrom(13.01, color)}
          {DateTo(a.date)}
          {MembersBlock(a.manager,a.designer)}
         
          <div className="w-[19.19%]  content-center">
            <div
              className="flex bg-[#739D00] h-[62px] justify-center items-center"
              onClick={() => handleOpenImage(k1, a.image)}
            >
              <p className="text-[2.3vw] font-rubik font-black  text-white">
                {a.fileName.slice(0, 4)}
              </p>
            </div>
          </div>
          {/* ----------------------------------------Show IMG----------------------------------------------------- */}
          {showItems === k1 && (
            <ShowItem
              url={image}
              setShowItems={setShowItems}
              loadingImage={loadingImage}
            />
          )}
          {/* --------------------------------------------------------------------------------------------- */}
          <div className="w-[31.57%] content-center">
            <p className="text-[1vw] font-rubik font-light text-xl text-black">
              {a.fileName.slice(4)}
            </p>
          </div>
          {/* -----------------------------------------print update---------------------------------------------------- */}
          <div className=" w-[10.10%] bg-[#739D00] content-center rounded-r-[8px]">
            <FaPrint className="text-white text-[2vw]" />
          </div>
          {/* --------------------------------------------------------------------------------------------- */}
        </div>
      ))}
    </React.Fragment>
  );
};
